import { userConstants } from "../../constant";

export function trackedOrder(state = [], action) {
  switch (action.type) {
    case userConstants.TRACK_ORDER:
      return {
        trackedOrder: action.payload,
      };
    default:
      return state;
  }
}
